import { render, staticRenderFns } from "./AuthorisationCallback.vue?vue&type=template&id=356b7da5&"
import script from "./AuthorisationCallback.vue?vue&type=script&lang=ts&"
export * from "./AuthorisationCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports